import { render, staticRenderFns } from "./DistributeSpacingHIcon.vue?vue&type=template&id=2b4f6f50&"
import script from "./DistributeSpacingHIcon.vue?vue&type=script&lang=js&"
export * from "./DistributeSpacingHIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports